import { useState } from "react";
import { useLang } from "@/context/lang-context";
import { LANGS, type Lang } from "@/lib/i18n";

// يُعرض مرّةً واحدة: لمستخدمٍ لا لغةَ محفوظة له. ثنائيّ اللغة عمداً — من لا
// يقرأ العربية يجب أن يفهم هذه الشاشة نفسها، وإلّا كانت أوّل حاجزٍ أمامه.
export function LanguagePicker() {
  const { lang, setLang, saveDefault, hasDefault } = useLang();
  const [dismissed, setDismissed] = useState(false);
  const [makeDefault, setMakeDefault] = useState(true);
  const [choice, setChoice] = useState<Lang>(lang);
  const [busy, setBusy] = useState(false);

  // لا يُعرض إلّا عند يقينٍ بأن لا لغةَ محفوظة له. `null` = لم يُعرَف بعد،
  // وعرضُه حينها هو ما جعل النافذة تظهر ثم تختفي فور وصول جواب الخادم.
  if (hasDefault !== false || dismissed) return null;

  async function confirm() {
    setBusy(true);
    // الافتراضي محفوظ (الاقتراح مؤشَّر مسبقاً): من اختار لغته مرّة لا يريد أن
    // تُسأل عنها كل صباح. ومن أزال العلامة تبقى لهذه الجلسة وحدها.
    if (makeDefault) await saveDefault(choice);
    else setLang(choice);
    setBusy(false);
    setDismissed(true);
  }

  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-6 text-center">
        <div className="text-3xl mb-2" aria-hidden>🌐</div>
        <div className="text-lg font-bold text-slate-800">اختر لغتك</div>
        <div className="text-lg font-bold text-slate-800 mb-1">Choose your language</div>
        <div className="text-xs text-slate-500 mb-5">
          تقدر تغيّرها لاحقاً من الإعدادات · You can change this later in Settings
        </div>

        <div className="grid grid-cols-2 gap-3 mb-4">
          {LANGS.map((l) => (
            <button
              key={l.code}
              onClick={() => setChoice(l.code)}
              aria-pressed={choice === l.code}
              className={`rounded-xl border-2 px-4 py-4 transition ${
                choice === l.code
                  ? "border-emerald-500 bg-emerald-50 text-emerald-800"
                  : "border-slate-200 hover:bg-slate-50 text-slate-700"
              }`}
            >
              <div className="text-base font-bold">{l.native}</div>
              <div className="text-[11px] text-slate-500">{l.label}</div>
            </button>
          ))}
        </div>

        <label className="flex items-center justify-center gap-2 text-xs text-slate-600 mb-5 cursor-pointer">
          <input type="checkbox" checked={makeDefault} onChange={(e) => setMakeDefault(e.target.checked)} />
          <span>اجعلها لغتي الافتراضية · Make this my default</span>
        </label>

        <button
          onClick={() => void confirm()}
          disabled={busy}
          className="w-full py-3 rounded-xl bg-emerald-600 text-white font-bold hover:bg-emerald-700 disabled:opacity-50"
        >
          متابعة · Continue
        </button>
      </div>
    </div>
  );
}
